module.exports = __webpack_public_path__ + "img/lbl-02.969762ed.png";